import React from "react";
import { ROLE, Space } from "@highnote/server/src/core/entities";
import { ReactComponent as EnterInheritedCircleSVG } from "App/common/icons/enter-inherited-circle.svg";
import { Tooltip } from "App/core/Tooltip";

export const InheritanceIndicator = ({
  entity,
  userId,
  member,
}: {
  entity: Space;
  userId: string;
  /**
   * The member document's own `inheritedRoles` and `hasDirectGrant`, which
   * are exact per-key mirrors of `entity.inheritedRolesV3[userId]` and
   * `!!entity.rolesV2[userId]`.
   *
   * Optional, and absent when the new read model is off. In that case the
   * two expressions below are byte-identical to what this component
   * computed before the roster read.
   */
  member?: { inheritedRoles: ROLE[]; hasDirectGrant: boolean };
}) => {
  const inheritedRoles = entity?.inheritedRolesV3 || {};
  const entityRoles = entity?.rolesV2 || {};
  const hasEntityRoles = member ? member.hasDirectGrant : !!entityRoles[userId];
  const isInheriting = member
    ? member.inheritedRoles.length > 0
    : !!inheritedRoles[userId];

  if (!isInheriting || !!hasEntityRoles) return null;

  return (
    <Tooltip title="This level of access is based on permissions given to the parent Collection(s). Changing it here will only affect access to this Space.">
      <div className="InheritanceIndicator">
        <EnterInheritedCircleSVG />
      </div>
    </Tooltip>
  );
};
